import React, { useEffect } from 'react';
import {Redirect} from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';



export const Signup = (props) => {
  const {loginWithRedirect} = useAuth0();
  useEffect(() => {
    loginWithRedirect({screen_hint: "signup"});
  }, []);

  return (
    <div/>
  )
}

export default Signup;